const mathFieldConfig = {
    autoCommands: 'pi sqrt',
    autoOperatorNames: 'sin cos tan arcsin arccos arctan ln exp abs sign fract', // log mod min max
}

export default mathFieldConfig